import { render, staticRenderFns } from "./PatientProfile.vue?vue&type=template&id=9902418e&scoped=true&"
import script from "./PatientProfile.vue?vue&type=script&lang=js&"
export * from "./PatientProfile.vue?vue&type=script&lang=js&"
import style0 from "./PatientProfile.vue?vue&type=style&index=0&id=9902418e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9902418e",
  null
  
)

export default component.exports